import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
import FormResources    from    './form_resources'

const Methods = {

    data() {
        return {
            notyf,
        }
    },

    watch: {
        form_data: {
            handler(val)
            {
                let keys = Object.keys(val);
                console.log(val)
                keys.forEach(item => 
                {
                    this.$refs.main_table.params[item] = val[item]
                });

                this.$refs.main_table.params['page'] = 1;
                // this.fetchMainList(this.$refs.main_table.params)
            },
            deep: true
         },
        
    },


    methods: {
       
       
        returnedAsssignmentsToParent(withoutChecking = false)
        {
            console.log(withoutChecking)
            if(this.use_parent)
            {
                if(this.assignments.length)
                {
                    return {...this.$refs.main_table.returnSelection(), params: this.$refs.main_table.params}
                }
            }
            else
            {
                if(this.assignments.length)
                {
                    return {...this.$refs.main_table.returnSelection(), params: this.$refs.main_table.params}
                }
            }
            return null
        },

        selectAllBoxes()
        {
            if(this.associates.length)
            {
                this.associates.map((item) => {
                    item.checked = this.selectAll
                })
            }
        },

        fill_data(data)
        {
            this.$emit('passInitialData', data)

            this.array_options = {
                associate_id: data.associates,
                shift_id: data.shifts,
                shift_class_id: FormResources.class_shift_options,
                group_id: data.groups,
                cost_center_department_id: data.cost_center_departments,
                supervisor_associate_id: data.supervisors,
                census: FormResources.options,
            
            }
        },

        resetList()
        {
            this.$refs.main_table.params['page'] = 1;
            this.fetchMainList(this.$refs.main_table.params)
        }

    },

}

export default Methods